import { InMemoryCache, makeVar } from '@apollo/client';
import { appraisalViewCache } from '../features/appraisalView/appraisalViewCache';
import { secondsToExpireCache } from '../features/timeoutWarning/services/secondsToExpireCache';
import { appraisalComparisonCache } from '../features/appraisalComparison/appraisalComparisonCache';
import { checkPointsCache } from '../features/checkPoints/checkPointsCache';
import { orgReportCache } from '../features/organizationReports/organizationReportsCache';
import { RECENT_UPDATES_NOTIFICATION_UNION_GRAPHQL_TYPES } from './constants/RecentUpdatesNotificationUnionGraphqlTypes';
import { TASKS_DUE_NOTIFICATION_UNION_GRAPHQL_TYPES } from './constants/tasksDueNotificationUnionGraphqlTypes';

export const isMenuCollapsed = makeVar(true);
export const userInfo = makeVar(undefined);
export const systemRole = makeVar(undefined);
export const supplementalRole = makeVar(undefined);
export const userPrivileges = makeVar([]);
export const userTier = makeVar(undefined);
export const userLicensedOrgUnitId = makeVar(undefined);
export const userLicensedOrgId = makeVar(undefined);

const buildCache = () =>
  new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          isMenuCollapsed: {
            read: isMenuCollapsed
          },
          userInfo: {
            read: userInfo
          },
          systemRole: {
            read: systemRole
          },
          supplementalRole: {
            read: supplementalRole
          },
          userPrivileges: {
            read: userPrivileges
          },
          userTier: {
            read: userTier
          },
          userLicensedOrgUnitId: {
            read: userLicensedOrgUnitId
          },
          userLicensedOrgId: {
            read: userLicensedOrgId
          },
          practiceAreaReport: {
            keyArgs: ['practiceAreaId'],
            merge(existing = {}, incoming) {
              return {
                ...existing,
                PracticeReports: [...(existing.PracticeReports || []), ...incoming.PracticeReports],
                ContinuationToken: incoming.ContinuationToken
              };
            }
          },
          ...checkPointsCache,
          ...orgReportCache,
          ...appraisalViewCache,
          ...appraisalComparisonCache,
          ...secondsToExpireCache
        }
      },
      AppraiserInfo: {
        keyFields: ['ExternalUserId']
      },
      AppraiserEvent: {
        keyFields: ['Id']
      },
      CheckPoint: {
        keyFields: ['Id']
      },
      CheckpointReappraisalRationaleReview: {
        keyFields: ['Id']
      },
      AppraiserEventBid: {
        keyFields: ['EventId']
      },
      AppraiserEventComment: {
        keyFields: ['Id']
      },
      AppraiserEventChangeDateRequest: {
        keyFields: ['Id']
      },
      OpenForATLBidEvent: {
        keyFields: ['Id']
      },
      TargetUserEventParticipationInfo: {
        keyFields: ['ExternalUserId', 'EventId']
      },
      ExecutiveSummary: {
        keyFields: ['OrgId']
      },
      LegalDocument: {
        keyFields: ['Id']
      },
      ObservationReport: {
        keyFields: ['Id']
      }
    },
    possibleTypes: {
      RecentUpdatesNotificationBase: [
        RECENT_UPDATES_NOTIFICATION_UNION_GRAPHQL_TYPES.APPRAISAL_NOTIFICATION_TYPENAME,
        RECENT_UPDATES_NOTIFICATION_UNION_GRAPHQL_TYPES.CHECKPOINT_NOTIFICATION_TYPENAME,
        // eslint-disable-next-line max-len
        RECENT_UPDATES_NOTIFICATION_UNION_GRAPHQL_TYPES.EVENT_CHANGE_DATE_REQUEST_EDIT_EVENT_REVIEW_NOTIFICATION_TYPENAME,
        RECENT_UPDATES_NOTIFICATION_UNION_GRAPHQL_TYPES.EVENT_CHANGE_DATE_REQUEST_REVIEW_PAGE_NOTIFICATION_TYPENAME,
        RECENT_UPDATES_NOTIFICATION_UNION_GRAPHQL_TYPES.OBSERVATION_REPORT_REVIEW_PAGE_NOTIFICATION_TYPENAME
      ],
      TasksDueNotificationBase: [
        TASKS_DUE_NOTIFICATION_UNION_GRAPHQL_TYPES.OBSERVATION_REPORT_NOTIFICATION_TYPENAME
      ]
    }
  });

export default buildCache;
